















import Glide from '@glidejs/glide';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Carousel extends Vue {
  private carousel: any = null;

  public mounted() {
    this.carousel = new Glide('.glide', {
      type: 'slider',
      perView: 3,
      startAt: 0,
      peek: 25,
      //   focusAt: 'center',
      breakpoints: {
        800: {
          perView: 2,
        },
        480: {
          perView: 1,
        },
      },
    }).mount();
  }
}
